export const manufacturerConstants = {
  FETCH_REQUEST: 'MANUFACTURER_FETCH_REQUEST',
  FETCH_SUCCESS: 'MANUFACTURER_FETCH_SUCCESS',
  FETCH_FAILURE: 'MANUFACTURER_FETCH_FAILURE',
  UPDATE_FOR_COLLECTION: 'MANUFACTURER_UPDATE_COLLECTION',
};
